// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__vpiKN","title":"ClientInsurance_title__2nOly","itemText":"ClientInsurance_itemText__pYwun"};